/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Request_Review_LabelInputs */



/**
* | output |
* | --- |
* | "Request review after publish" |
*
* @param {Iconik_Publish_Request_Review_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_request_review_label = /** @type {((inputs?: Iconik_Publish_Request_Review_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Request_Review_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "de") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "it") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "es") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Request review after publish")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Request review after publish")
	return /** @type {LocalizedString} */ ("Request review after publish")
});